import ChangePassword from './ChangePassword/ChangePassword';
import DeleteAccount from './DeleteAccount';
import GeneralData from './GeneralData';

const UserProfile = () => {

    return (
        <div className='user-profile-container'>
            <GeneralData />
            <ChangePassword />
            <DeleteAccount />
        </div>
    );
};

export default UserProfile;